export const WEBHOOK_ENABLED_DISPLAY = [
  { title: 'Active', value: true },
  { title: 'Inactive', value: false },
];
